import { Wrapper } from "../styles/Output.styled";

const GeneralOutput = ({ children }) => (
  <Wrapper>{children}</Wrapper>
);

export default GeneralOutput;
